import React, { Component } from 'react';
import {
    FormGroup, ControlLabel, FormControl,
    Grid, Row, Col
} from 'react-bootstrap';

import Card from '../../components/Card/Card.jsx';
import UserCard from '../../components/Card/UserCard.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import SweetAlert from "react-bootstrap-sweetalert";

import UserService from "../../services/UserService";
import { APP_HOST } from '../../variables/api-config';


class UserPage extends Component {
  constructor(props) {
    super(props);
    //this.vForm = this.refs.vForm;
    this.action = this.props.match.params.number ? "edit" : "create";
    this.userid = parseInt(this.props.match.params.number, 10);
    this.state = {
      alert: null,
      // Register
      username: "",
      email: "",
      password: "",
      cfpassword: "",
      usernameError: null,
      emailError: null,
      passwordError: null,
      cfpasswordError: null,
      rolesSelected: [],
      imageFile: null,
      imagePreviewUrl: '',
      originalImagePreviewUrl: '',
      uploadButtonLabel: 'Seleccionar Imagen',
      uploadButtonStyle: 'primary',
      disabledCancel: true,
    };
    this.userService = new UserService();
    this.currentUser = this.userService.getProfile();
    //this.errorAlert = this.errorAlert.bind(this);
    this.populateUser();
    this._handleImageChange = this._handleImageChange.bind(this);
    this._changeImage = this._changeImage.bind(this);
    this._cancelImage = this._cancelImage.bind(this);
  }

  _cancelImage(e) {
    let original = this.state.originalImagePreviewUrl;
    this.setState({
      imageFile: null,
      imagePreviewUrl: original,
      uploadButtonLabel: 'Seleccionar Imagen',
      uploadButtonStyle: 'primary',
      disabledCancel: true
    });
  }
  _changeImage(event){
    if (this.state.imageFile === null){
      this.uploadInput.click();
    } else { // upload
      event.preventDefault();
      this.userService
        .uploadUserAvatar(
          this.currentUser.id,
          this.uploadInput.files[0]
        )
        .then(res => {
          let currentImage = this.state.imagePreviewUrl;
          this.setState({
            imageFile: null,
            originalImagePreviewUrl: currentImage,
            uploadButtonLabel: 'Seleccionar Imagen',
            uploadButtonStyle: 'primary',
            disabledCancel: true
          });
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Usuario actualizado satisfactoriamente!</div>), 10);
        })
        .catch(err => {
          this.errorAlert((<div>Ha ocurrido un error mientras se actualizaban los datos del usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });
    }
  }
  _handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = this.uploadInput.files[0];

    reader.onloadend = () => {
      this.setState({
        imageFile: file,
        imagePreviewUrl: reader.result,
        uploadButtonLabel: 'Guardar Imagen',
        uploadButtonStyle: 'success',
        disabledCancel: false,
      });
    }

    reader.readAsDataURL(file)
  }

  hideAlert() {
    this.setState({
        alert: null,
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  populateUser() {
    this.userService
      .getUser(this.currentUser.id)
      .then(res => {
        this.setState({
          username: res.user.username,
          email: res.user.email,
          rolesSelected: res.user.roles,
          imagePreviewUrl: APP_HOST + '/avatar/' + res.user.avatar,
          originalImagePreviewUrl: APP_HOST + '/avatar/' + res.user.avatar,
        });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert((<div>Ha ocurrido un error mientras se obtenian los datos del usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  handleUserNameChange(event) {
    this.setState({ username: event.target.value });
    event.target.value.length < 6
      ? this.setState({
          usernameError: (
            <small className="text-danger">
              El nombre de usuario debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ usernameError: null });
  }
  handleEmailChange(event) {
    this.setState({ email: event.target.value });
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email es requerido y el formato debe ser
              <i>usuario@dominio.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
    event.target.value.length < 6
      ? this.setState({
          passwordError: (
            <small className="text-danger">
              La contraseña debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ passwordError: null });
  }
  handleCfPasswordChange(event) {
    this.setState({ cfpassword: event.target.value });
    event.target.value !== this.state.password
      ? this.setState({
          cfpasswordError: (
            <small className="text-danger">Las contraseñas no coinciden.</small>
          )
        })
      : this.setState({ cfpasswordError: null });
  }
  handleRegisterSubmit() {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(this.state.email) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email es requerido y el formato debe ser
              <i>usuario@dominio.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
      // edit
      if (this.state.password.length > 1) {
        // si ha escrito algo en el campo es que quiere cambiar el password
        // cambio de contraseña
        this.state.password.length < 6
          ? this.setState({
              passwordError: (
                <small className="text-danger">
                  La contraseña debe ser de al menos 6 caracteres.
                </small>
              )
            })
          : this.setState({ passwordError: null });
        this.state.cfpassword !== this.state.password
          ? this.setState({
              cfpasswordError: (
                <small className="text-danger">
                  Las contraseñas no coinciden.
                </small>
              )
            })
          : this.setState({ cfpasswordError: null });
      }
    this.state.username.length < 6
      ? this.setState({
          usernameError: (
            <small className="text-danger">
              El nombre de usuario debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ usernameError: null });

    //edit
    if (
      this.state.emailError == null &&
      this.state.passwordError == null &&
      this.state.cfpasswordError == null &&
      this.state.usernameError == null
    ) {
      this.userService
        .updateUser(
          this.currentUser.id,
          this.state.username,
          this.state.email,
          this.state.rolesSelected,
          this.state.password
        )
        .then(res => {
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Usuario actualizado satisfactoriamente!</div>), 10);
        })
        .catch(err => {
          this.errorAlert((<div>Ha ocurrido un error mientras se actualizaban los datos del usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });
    }
  }
  render() {
    let imagePreviewUrl = this.state.imagePreviewUrl;

    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Perfil"
                content={
                  <form>
                    <div>
                      <FormGroup>
                        <ControlLabel>
                          Nombre de usuario:
                          <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="username"
                          autoComplete="username"
                          value={this.state.username}
                          onChange={event => this.handleUserNameChange(event)}
                        />{" "}
                      {this.state.usernameError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Email:
                          <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="email"
                          autoComplete="email"
                          value={this.state.email}
                          onChange={event => this.handleEmailChange(event)}
                        />{" "}
                        {this.state.emailError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Contraseña:
                        </ControlLabel>
                        <FormControl
                          type="password"
                          name="password"
                          autoComplete="current-password"
                          onChange={event => this.handlePasswordChange(event)}
                        />{" "}
                        {this.state.passwordError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Confirme contraseña:
                        </ControlLabel>
                        <FormControl
                          type="password"
                          name="cfpassword"
                          autoComplete="current-password"
                          onChange={event => this.handleCfPasswordChange(event)}
                        />
                        {this.state.cfpasswordError}
                      </FormGroup>
                      <div className="category">
                        <span className="star">*</span>
                        Campos requeridos
                      </div>
                      <div className="category">
                        <span>
                          Deje vacíos los campos de "Contraseña" si no desea cambiarla
                        </span>
                      </div>
                    </div>
                  </form>
                }
                legend={
                  <div style={{ textAlign: "right" }}>
                    <Button
                      bsStyle="info"
                      fill={true}
                      wd={true}
                      onClick={this.handleRegisterSubmit.bind(this)}
                    >
                      Actualizar perfil
                    </Button>
                  </div>
                }
              />
              </Col>
              <Col md={4}>
                <UserCard
                  bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                  avatar={imagePreviewUrl}
                  name={this.state.username}
                  extras={
                    <div>
                      <form>
                        <input accept="image/x-png,image/gif,image/jpeg" ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this._handleImageChange} />

                        <Button bsStyle={this.state.uploadButtonStyle} fill={true} wd={true} onClick={this._changeImage}>
                          {this.state.uploadButtonLabel}
                        </Button>
                        <Button disabled={this.state.disabledCancel} onClick={this._cancelImage} bsStyle="danger" fill={true}>
                          <i className="fa fa-ban"></i>
                        </Button>
                      </form>
                    </div>
                  }
                />
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }
}

export default UserPage;



// WEBPACK FOOTER //
// ./src/views/Pages/UserPage.jsx